import { useLayoutEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const useScrollToError = () => {
  const { errors } = useFormContext();

  useLayoutEffect(() => {
    const fields = Object.keys(errors);
    if (fields.length > 0) {
      document
        .querySelector(`[name='${fields.shift()}']`)
        ?.parentElement?.scrollIntoView({ block: 'center', inline: 'nearest' });
      const invalidInput = document.querySelector('[aria-invalid="true"]') as HTMLInputElement | undefined;
      invalidInput?.focus();
    }
  }, [errors]);
};
